import { authorizeIfLoggedIn } from "../../../components/Auth/AuthorizedApiClientBase";
import { PortfoliosClient } from "./generated/PortfoliosClient";

export const PortfoliosClientFactory = () => {
    const portfoliosClient = new PortfoliosClient(process.env.PORTFOLIO_BACKEND_URL);
    authorizeIfLoggedIn(portfoliosClient);

    return portfoliosClient;
}